module.exports = __webpack_public_path__ + "img/dummy_image_seller.e910eb0b.svg";